import React from "react";
import PersonIcon from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import DescriptionIcon from "@material-ui/icons/Description";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixPaymentDetailsProps } from "../types";

const PixPaymentDetails: React.FC<PixPaymentDetailsProps> = ({
  receiver,
  bank,
  transactionId,
  issueDate,
  paymentStatus,
}) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";

  return (
    <div className={classes.paymentDetails}>
      <div className={classes.paymentRow}>
        <span className={classes.paymentRowLabel}>
          <PersonIcon style={{ fontSize: 14 }} />
          RECEBEDOR
        </span>
        <span className={classes.paymentRowValue}>{receiver}</span>
      </div>
      <div className={classes.paymentRow}>
        <span className={classes.paymentRowLabel}>
          <AccountBalanceIcon style={{ fontSize: 14 }} />
          BANCO
        </span>
        <span className={classes.paymentRowValue}>{bank}</span>
      </div>
      <div className={classes.paymentRow}>
        <span className={classes.paymentRowLabel}>
          <DescriptionIcon style={{ fontSize: 14 }} />
          ID DA TRANSAÇÃO
        </span>
        <span
          className={`${classes.paymentRowValue} ${
            isPending
              ? classes.paymentRowValueHighlight
              : classes.paymentRowValueHighlightGreen
          }`}
        >
          {transactionId}
        </span>
      </div>
      <div className={classes.paymentRow}>
        <span className={classes.paymentRowLabel}>
          <CalendarTodayIcon style={{ fontSize: 14 }} />
          DATA DE EMISSÃO
        </span>
        <span className={classes.paymentRowValue}>{issueDate}</span>
      </div>
    </div>
  );
};

export default PixPaymentDetails;
